import { BaseError } from './BaseError';

export class PropertyRequiredError extends BaseError {
  constructor({ name, value }: { name: string; value: any }) {
    super(`Property "${name}" is required. Received value "${value}"`);
  }
}
